import { useTheme } from 'vuetify';


export const useThemeStore = defineStore('themeStore', () => {
  const darkmode = ref(localStorage.getItem('DarkMode') === 'true');
  const theme = useTheme();

  theme.change(!darkmode.value ? 'light' : 'dark');

  function toggleTheme(newValue: boolean) {
    darkmode.value = newValue;
    localStorage.setItem('DarkMode', newValue.toString());
    theme.change(!newValue ? 'light' : 'dark');
  }

  return { toggleTheme, darkmode };
});
